import { useEffect } from 'react';

import { useIntl } from 'react-intl';
import Toast from 'react-native-toast-notifications';

import { IServerOrder } from '@rbi-ctg/menu';
import { modalToaster } from 'components/toaster/refs';
import { toaster } from 'components/toaster/toaster';

let prevTotalCents: number | null = null;

export const OrderPriceChangeToast = ({ serverOrder }: { serverOrder: IServerOrder | null }) => {
  const { formatMessage } = useIntl();
  const toastMessage = formatMessage({ id: 'restaurantPriceChangeToast' });
  const currentCartTotal = serverOrder?.cart.totalCents ?? null;

  useEffect(() => {
    if (!currentCartTotal) {
      return;
    }

    // If there isn't a previous total, set it and do nothing else.
    // Only display the toast if the total changes.
    if (prevTotalCents === null) {
      prevTotalCents = currentCartTotal;
      return;
    }

    if (currentCartTotal !== prevTotalCents) {
      toaster.positive(toastMessage);
      prevTotalCents = null;
    }
  }, [currentCartTotal, toastMessage]);

  return (
    <Toast
      ref={x => {
        modalToaster.current = x;
      }}
    />
  );
};
